import React from "react";
import { observer } from "mobx-react";
import { IInfoPopoverProps } from "../InfoPopover/InfoPopover";
import { Select } from "../Select/Select";
import { ISelectOption } from "netbank-shared/src/libs/models/Select/SelectOption";

interface IDropdownProps {
  list: ISelectOption[];
  value?: string;
  label?: string;
  subtext?: string;
  innerLabel?: string;
  icon?: string;
  disabled?: boolean;
  fontWeight?: string;
  suffix?: string;
  suffixLabel?: string;
  infoPopover?: IInfoPopoverProps;
  error?: string;
  borderless?: boolean;
  smallChevron?: boolean;
  onChange: (item: ISelectOption) => void;
  onOpen?: () => void;
  onClose?: () => void;
  staticValue?: string;
}

export const Dropdown = observer(
  ({
    list,
    value,
    label,
    subtext,
    innerLabel,
    icon,
    disabled,
    suffix,
    suffixLabel,
    staticValue,
    infoPopover,
    error,
    onChange,
    onOpen,
    onClose,
  }: IDropdownProps): JSX.Element => {
    
    const targetList = staticValue ? [] : list;
    if(staticValue){
      targetList.push({
        value: staticValue,
        label: staticValue,
        valueSuffix: suffix,
      });
    }

    const selectedIndex = targetList.findIndex((item) => `${item.label}${item.valueSuffix || ""}` === value);
    return (
      <Select
        options={targetList}
        value={selectedIndex > -1 ? targetList[selectedIndex] : null}
        onChange={onChange}
        onOpen={onOpen}
        onClose={onClose}
        icon={icon}
        error={error}
        infoPopover={infoPopover}
        placeholder={innerLabel}
        label={label}
        subtext={subtext}
        suffix={suffix}
        disabled={disabled}
        suffixLabel={suffixLabel}
        isMulti={false}
      />
    );
  }
);
